import { Colors } from '../../consts/Colors';
import RoundedButton2 from '../RoundedButton2';
import Card3 from './Card3';
import { CartesInfos, TextContents } from '../../consts/DataGame3';
import DragManager from '../DragManager';
import { tags } from '../../consts/Tags';

// Création du deck de jeu pour la partie 1

export default class Deck3 extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.num = this.scene.game.data.cardNumber2 + 1
        this.cardNumber2 = this.scene.game.data.cardNumber2
        this.isFirstDrop = true

        this.dragManager = new DragManager(this.scene);
        this.rect = this.scene.add.rexRoundRectangle(-200, 0, 820, 260, 26, Colors.Elmt.Blue).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);


        this.rectLabel = this.scene.add.rexRoundRectangle(this.rect.width / 2 - 10, 0, 212, 260, {
            tl: 0,
            tr: 26,
            bl: 0,
            br: 26
        }, Colors.Elmt.White).setOrigin(1, 0.5);
        this.add(this.rectLabel);
        // this.rectLabel.setAlpha(0)

        this.labelName = this.scene.add.rexTagText(220, 85, 'Mandat ad hac', {
            fontSize: "24px",
            fontFamily: "MassiliaExtraBold",
            align: "left",
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            tags: tags,
            wordWrap: { width: 187, useAdvancedWrap: true }
        }).setOrigin(0, 0.5)
        this.add(this.labelName)

        this.numText = this.scene.add.text(220, this.labelName.y - this.labelName.height / 2 - 30, this.num + "/6", {
            font: "20px MassiliaExtraLight",
            color: Colors.Text.Blue
        }).setOrigin(0)
        this.add(this.numText)
        // this.numText.setAlpha(0)

        // this.labelName.setAlpha(0)

        this.repLogo = this.scene.add.image(-420, -85, 'goodAnswer').setOrigin(0.5);
        this.add(this.repLogo);
        this.repLogo.setAlpha(0)

        this.repText = this.scene.add.text(-386, -85, "BONNE RÉPONSE", {
            font: "40px MassiliaBold",
            color: Colors.Text.Red
        }).setOrigin(0, 0.5)
        this.add(this.repText)
        this.repText.setAlpha(0)

        this.cardFeedBack = this.scene.add.text(-580, -50, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "left",
            lineSpacing: 5,
            wordWrap: { width: 760, useAdvancedWrap: true }
        }).setOrigin(0)
        this.add(this.cardFeedBack)
        this.cardFeedBack.setAlpha(0)

        this.nextBtn = new RoundedButton2(this.scene, -200, 90, 160, "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setAlpha(0)
        this.nextBtn.setClickFunction(() => {
            this.card.destroy()
            this.nextBtn.setAlpha(0)
            if (this.isFirstDrop === true) {
                this.scene.game.data.score.bravo++
            } else {
                this.isFirstDrop = true

            }
            if (this.num === 6) {
                this.card.destroy()
                this.scene.launchEndBoard()
            } else {
                this.setDeckAction(CartesInfos[this.scene.game.data.cardNumber2])
                this.scene.zones.forEach(x => {
                    if (x.isError) {
                        x.setActive()
                    }
                });
            }
        })

        this.restartBtn = new RoundedButton2(this.scene, -200, 90, 160, "Réessayer");
        this.add(this.restartBtn);
        this.restartBtn.setAlpha(0)
        this.restartBtn.setClickFunction(() => {
            if (this.isFirstDrop === true) {
                this.scene.game.data.score.mauvais++
                this.isFirstDrop = false
            }
            this.card.destroy()

            this.restartBtn.setAlpha(0)
            this.setDeckAction(CartesInfos[this.scene.game.data.cardNumber2])
            this.scene.zones.forEach(x => {
                if (x.isError) {
                    x.item.setTexture('imgPlaceholder');
                    x.item.setTint(Colors.Elmt.Red);
                    x.item.setScale(1);
                    x.itemStroke.destroy()
                }
            });
        })

        this.title = this.scene.createTextElement(-986, -107, TextContents.title)
        this.subtitle = this.scene.createTextElement(-986, -80, TextContents.subtitle)
        this.consigne = this.scene.createTextElement(450, 65, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)


    }

    setDeckAction(cardData) {
        // this.isFirstDrop = true
        this.cardData = cardData
        this.card = new Card3(this.scene, -200, 30, this.cardData, this);
        this.dragManager.addDraggable(this.card);
        this.add(this.card);
        this.repLogo.setAlpha(0)
        this.repText.setAlpha(0)
        this.cardFeedBack.setAlpha(0)

        this.labelName.setText(this.cardData.titre)
        this.rect.fillColor = Colors.Elmt.Blue
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.rectLabel.fillColor = Colors.Elmt.White
        this.numText.setColor(Colors.Text.Blue)
        this.labelName.setColor(Colors.Text.Blue)
        this.num = this.scene.game.data.cardNumber2 + 1
        this.numText.setText(this.num + "/6")
        this.rectLabel.setAlpha(0)
        this.numText.setAlpha(1)
        this.labelName.setAlpha(1)
    }
    setDeckTrue(content) {
        this.repLogo.setAlpha(1)
        this.repText.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.nextBtn.setAlpha(1)
        this.repLogo.setTexture('goodAnswer')
        this.repText.setText("BONNE RÉPONSE")
        this.repText.setFill(Colors.Text.Green)
        this.cardFeedBack.setText(content)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Green, 1);
        this.rectLabel.fillColor = Colors.Elmt.Green
        this.numText.setColor(Colors.Text.White)
        this.numText.setPosition(220, this.labelName.y - this.labelName.height / 2 - 30)
        this.labelName.setColor(Colors.Text.White)
        this.rectLabel.setAlpha(1)
    }
    setDeckFalse(content, presque) {
        let repTextContent = "MAUVAISE RÉPONSE"
     
        if (presque) {
            repTextContent = "ATTENTION !"
        }
        this.repLogo.setAlpha(1)
        this.repText.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.restartBtn.setAlpha(1)
        this.repLogo.setTexture('badAnswer')
        this.repText.setText(repTextContent)
        this.repText.setFill(Colors.Text.Red)
        this.cardFeedBack.setText(content)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Red, 1);
        this.rectLabel.fillColor = Colors.Elmt.Red
        this.numText.setColor(Colors.Text.White)
        this.numText.setPosition(220, this.labelName.y - this.labelName.height / 2 - 30)
        this.labelName.setColor(Colors.Text.White)
        this.rectLabel.setAlpha(1)

    }




}